import React from 'react';
import ReactECharts from 'echarts-for-react';
import tdTheme from '../dark.json';
import { registerTheme } from 'echarts';
import { StatusColor } from '../../../environment';

export interface ILabelsAndValuesRingGaugeProps {
    centerLabel: string;
    centerValue: number;
    leftLabel: string;
    leftValue: number;
    label1: string;
    value1: number
    label2: string;
    value2: number
    label3: string;
    value3: number
    label4: string;
    value4: number
    label5: string;
    value5: number
}
export interface IRingGaugeProps {
    title: string;
    subTitle: string;
    labelAndValues: ILabelsAndValuesRingGaugeProps;
}

export const RingGauge: React.FC<IRingGaugeProps> = (props : IRingGaugeProps) => {

    registerTheme('tdTheme', tdTheme);


    const gaugeData = [
        {
            value: 10.3,
            itemStyle: {
                color: StatusColor.noRun
            },
            name: 'No Run',
            textStyle: {
                color: StatusColor.noRun
            },
            title: {
                offsetCenter: ['130%', '-110%'],
            },
            detail: {
                valueAnimation: true,
                offsetCenter: ['130%', '-90%']
            }
        },
        {
            value: 60.7,
            itemStyle: {
                color: StatusColor.passed
            },
            name: 'Passed',
            title: {
                offsetCenter: ['130%', '-60%']
            },
            detail: {
                valueAnimation: true,
                offsetCenter: ['130%', '-40%']
            }
        },
        {
            itemStyle: {
                color: StatusColor.failed
            },
            value: 12.6,
            name: 'Failed',
            title: {
                offsetCenter: ['130%', '-10%']
            },
            detail: {
                valueAnimation: true,
                offsetCenter: ['130%', '10%'],
            }
        },
        {
            itemStyle: {
                color: StatusColor.blocked
            },
            value: 7.4,
            name: 'Blocked',
            title: {
                offsetCenter: ['130%', '40%']
            },
            detail: {
                valueAnimation: true,
                offsetCenter: ['130%', '60%']
            }
        },
        {
            itemStyle: {
                color: StatusColor.warning
            },
            value: 10,
            name: 'Warning',
            title: {
                offsetCenter: ['130%', '90%']
            },
            detail: {
                valueAnimation: true,
                offsetCenter: ['130%', '110%']
            }
        },
        {
            itemStyle: {
                color: StatusColor.passed
            },
            value: props.labelAndValues.centerValue,
            name: props.labelAndValues.centerLabel,
            title: {
                offsetCenter: ['0%', '-10%']
            },
            detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '10%']
            }
        },
        {
            itemStyle: {
                color: StatusColor.noRun
            },
            value: 85,
            name: 'Total \n Executed',
            title: {
                offsetCenter: ['-130%', '80%']
            },
            detail: {
                valueAnimation: true,
                offsetCenter: ['-130%', '110%']
            }
        }
    ];

    const options = {
        title: {
            text: props.title,
            subtext: props.subTitle,
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        series: [
            {
                type: 'gauge',
                startAngle: 90,
                endAngle: -270,
                pointer: {
                    show: false
                },
                progress: {
                    show: true,
                    overlap: false,
                    roundCap: true,
                    clip: false,
                    itemStyle: {
                        borderWidth: 0,
                        borderColor: 'inherit',
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 40
                    }
                },
                splitLine: {
                    show: false,
                    distance: 0,
                    length: 120
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    show: false,
                    distance: 50
                },
                data: gaugeData,
                title: {
                    fontSize: 14
                },
                detail: {
                    width: 40,
                    height: 14,
                    fontSize: 12,
                    color: 'inherit',
                    borderColor: 'inherit',
                    borderRadius: 20,
                    borderWidth: 1,
                    formatter: '{value}%'
                },
            }
        ]
    };

    return <ReactECharts
        option={options}
        theme='tdTheme'
    />;
};

